import { c as _c } from "react/compiler-runtime";
import { Box, Button, Card, Separator, Text, VStack } from '@chakra-ui/react';
import { NavGroup } from '@src/components/sco/Advisors/layout/NavGroup';
import { AdvisorsPaths, useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { isPublicAdvisorProfilePath } from '@src/components/sco/Advisors/utils/advisorProfileHub';
import { SidebarNestedNavList, SidebarNestedNavListSection } from '@src/components/sco/SidebarNestedNavList';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { useLoginHref } from '@src/hooks/useLoginHref';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { LuHouse, LuLayoutGrid, LuSearch } from 'react-icons/lu';
const normalizePath = (path: string) => path.split('?')[0].split('#')[0];

/** Only the guest-reachable Advisors routes (L3). No viewer queries, no badge counts. */
export const advisorsGuestNavSections = (asPath: string, paths: Pick<AdvisorsPaths, 'base' | 'browse' | 'directory' | 'profile'>): SidebarNestedNavListSection[] => {
  const path = normalizePath(asPath);
  return [{
    title: 'Overview',
    href: paths.base,
    icon: LuHouse,
    isActive: path === paths.base
  }, {
    title: 'Find Advisors',
    href: paths.directory,
    icon: LuSearch,
    isActive: path === paths.directory || path.startsWith(`${paths.directory}/`) || isPublicAdvisorProfilePath(path, paths.profile)
  }, {
    title: 'Browse by topic',
    href: paths.browse,
    icon: LuLayoutGrid,
    isActive: path === paths.browse
  }];
};

/** Left nav for logged-out visitors on guest-allowed Advisors routes. */
export const AdvisorsGuestNav = () => {
  const $ = _c(17);
  const router = useRouter();
  const paths = useAdvisorsPaths();
  const loginHref = useLoginHref();
  let t0;
  if ($[0] !== paths || $[1] !== router.asPath) {
    t0 = advisorsGuestNavSections(router.asPath, paths);
    $[0] = paths;
    $[1] = router.asPath;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const sections = t0;
  let t1;
  if ($[3] !== sections) {
    t1 = <Box flex={1} minHeight={0} overflowY="auto" paddingX={1} paddingY={4} width="full"><NavGroup label="Advisors"><SidebarNestedNavList accordionBehavior="expand-only" sections={sections} /></NavGroup></Box>;
    $[3] = sections;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Separator />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Card.Body alignItems="center" gap={1} textAlign="center"><Text fontWeight="semibold">Become an Advisor</Text><Text color="colorPalette.fg/70" fontSize="xs">Join boards for equity, or offer paid sessions.</Text></Card.Body>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== paths.becomeAStartupAdvisor) {
    t4 = <Card.Root asChild={true} colorPalette="yellow" size="sm" variant="interactive"><NextLink href={paths.becomeAStartupAdvisor}>{t3}</NextLink></Card.Root>;
    $[7] = paths.becomeAStartupAdvisor;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== loginHref) {
    t5 = <Button asChild={true} size="sm" variant="outline" width="full"><NextLink href={loginHref}>Log in</NextLink></Button>;
    $[9] = loginHref;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <VStack align="stretch" gap={3} marginTop={3} paddingX={1} width="full">{t4}{t5}</VStack>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t6) {
    t7 = <VStack align="stretch" gap={0} height="full" minHeight={0} width="full">{t1}{t2}{t6}</VStack>;
    $[14] = t1;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};